module.exports = __webpack_public_path__ + "static/media/house_front.32f12d9c.png";